import { AloftPrice } from '@aloft/toolkit-shared';

import { selectCalculatedMarketAdjustment } from '../../../../redux/features/selectors/calculatedMarketAdjustmentSelectors/selectCalculatedMarketAdjustment.ts';
import { selectUnadjustedSiteCost } from '../../../../redux/features/selectors/selectUnadjustedSiteCost.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';

export const useSiteValueCalculationString = (id: string): string => {
  const unadjustedSite =
    useAppSelector((state) => selectUnadjustedSiteCost(state, id)) ?? AloftPrice.zero;
  const marketAdjustment = useAppSelector((state) => selectCalculatedMarketAdjustment(state, id));
  const siteValue = unadjustedSite.add(marketAdjustment).toString(true);

  return `${unadjustedSite.toString(true)} + ${marketAdjustment.toString(true)} = ${siteValue}`;
};
